import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, ArrowDownLeft, QrCode, PlusCircle, Landmark } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { formatRupiah, formatDateTime, txnDisplay, STATUS_LABEL } from "../lib/format";

const typeIcon = (txn) => {
  if (txn.type === "topup_va") return { Icon: PlusCircle, cls: "bg-emerald-50 text-emerald-600" };
  if (txn.type === "qris_payment" || txn.type === "qris_receive") return { Icon: QrCode, cls: txn.direction === "in" ? "bg-emerald-50 text-emerald-600" : "bg-teal-50 text-[#0FA5A0]" };
  if (txn.type === "transfer_bank") return { Icon: Landmark, cls: "bg-blue-50 text-primary" };
  return txn.direction === "in"
    ? { Icon: ArrowDownLeft, cls: "bg-emerald-50 text-emerald-600" }
    : { Icon: ArrowUpRight, cls: "bg-blue-50 text-primary" };
};

const statusBadge = {
  SUCCESS: "bg-emerald-50 text-emerald-600 border-emerald-100",
  PENDING: "bg-amber-50 text-amber-600 border-amber-100",
  FAILED: "bg-red-50 text-red-600 border-red-100",
};

export const TransactionRow = ({ txn }) => {
  const { title, subtitle } = txnDisplay(txn);
  const { Icon, cls } = typeIcon(txn);
  const isIn = txn.direction === "in";
  return (
    <Link
      to={`/transaksi/${txn.id}`}
      data-testid="transaction-row"
      className="flex items-center gap-3 px-4 py-3.5 hover:bg-secondary/60 transition-[background-color] duration-200 rounded-xl"
    >
      <div className={`h-10 w-10 shrink-0 rounded-full flex items-center justify-center ${cls}`}>
        <Icon className="h-5 w-5" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-sm font-medium truncate">{title}</p>
        <p className="text-xs text-muted-foreground truncate">{subtitle} · {formatDateTime(txn.created_at)}</p>
      </div>
      <div className="text-right shrink-0">
        <p className={`text-sm font-semibold tabular-nums ${isIn ? "text-emerald-600" : "text-foreground"}`} data-testid="transaction-row-amount">
          {isIn ? "+" : "-"}{formatRupiah(txn.amount)}
        </p>
        <Badge variant="outline" className={`text-[10px] mt-0.5 ${statusBadge[txn.status] || ""}`} data-testid="transaction-row-status">
          {STATUS_LABEL[txn.status] || txn.status}
        </Badge>
      </div>
    </Link>
  );
};
